module.exports = __webpack_public_path__ + "images/handarrow-02a9cd2c51d515de59476a9fafce9115.svg";